module.exports = __webpack_public_path__ + "fonts/inter-v3-latin-ext_latin-600.6d00aed.woff";